<template>
	<DashboardCard icon="frame_inspect" :heading="messages.heading">
		<div class="col-span-3 space-y-5">
			<DashboardMetricWithIcon
				class="col-span-3"
				:label="messages.label"
				variant="circle"
				:icon
				:value="description"
				:palette
				:link-to="{ name: 'LoanApplicationEditPage' }"
			/>
		</div>
	</DashboardCard>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
	formHasIssues?: boolean;
}>();
const messages = {
	heading: "Aanvraagvalidatie",
	label: "Opmerkingen",
	hasIssues: "Er zijn nog opmerkingen bij de offerteaanvraag",
	hasNoIssues: "Geen opmerkingen bij de offerteaanvraag",
	loading: "Opmerkingen ophalen...",
};

const icon = computed(() => {
	if (props.formHasIssues === undefined) {
		return "pending";
	}

	return props.formHasIssues ? "warning" : "check";
});
const palette = computed(() => "gray" as const);
const description = computed(() => {
	if (props.formHasIssues === undefined) {
		return messages.loading;
	}

	return props.formHasIssues ? messages.hasIssues : messages.hasNoIssues;
});
</script>
